import customaxios from ".";

/**
 * 1) Calendar (month view) - dots/marked days
 * GET /api/provider-dashboard/booking-appointment/calendar/?timezone=...&month=YYYY-MM
 */
export const getBookingAppointmentCalendar = (params: {
  timezone: string; // "Asia/kolkata"
  month: string;    // "2026-02"
}) => {
  return customaxios({
    method: "GET",
    url: `/provider-dashboard/booking-appointment/calendar/`,
    params,
  });
};

/**
 * 2) Bookings by selected date (right side list)
 * GET /api/provider-dashboard/booking-appointment/by-date/?timezone=...&date=YYYY-MM-DD
 */
export const getBookingAppointmentsByDate = (params: {
  timezone: string; // "Asia/kolkata"
  date: string;     // "2026-02-16"
}) => {
  return customaxios({
    method: "GET",
    url: `/provider-dashboard/booking-appointment/by-date/`,
    params,
  });
};

/**
 * 3) Booking details screen
 * NOTE: orderId = bookingId from calendar/by-date response
 * GET /api/provider-dashboard/booking-appointment/details/:orderId?timezone=...
 */
export const getBookingAppointmentDetails = (params: {
  timezone: string;                 // "Asia/Kolkata"
  bookingId: number | string;       // numeric bookingId from calendar API
}) => {
  const { bookingId, timezone } = params;

  // in case someone accidentally passes "#ORD000959", try to extract digits
  const numericId =
    typeof bookingId === "string"
      ? bookingId.replace(/[^\d]/g, "")
      : String(bookingId);

  return customaxios({
    method: "GET",
    url: `/provider-dashboard/booking-appointment/details/${numericId}`,
    params: { timezone },
  });
};

export const uploadBookingDocuments = (orderId: number | string, formData: FormData) => {
  return customaxios({
    method: "POST",
    url: `/provider-dashboard/booking-appointment/upload-documents/${orderId}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const deleteBookingDocument = (documentId: number | string) => {
  return customaxios({
    method: "DELETE",
    url: `/provider-dashboard/booking-appointment/delete-document/${documentId}`,
  });
}
export const updateBookingStatus = (orderId: number | string) => {
  return customaxios({
    method: "POST",
    url: `/provider-dashboard/booking-appointment/completed/${orderId}`
  });
}

